// reducers/similarProductsReducer.js
const initialState = {
  loading: false,
  products: [], // array of similar products
  error: null,
};

export const similarProductReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SIMILAR_PRODUCTS_REQUEST":
      return { ...state, loading: true };

    case "SIMILAR_PRODUCTS_SUCCESS":
      return { loading: false, products: action.payload, error: null };

    case "SIMILAR_PRODUCTS_FAILURE":
      return { loading: false, products: [], error: action.payload };

    default:
      return state;
  }
};
